import { useQueries } from "@tanstack/react-query";
import { usePathname } from "@utils/hook/index.hook";
import React from "react";
import { useParams } from "react-router";

type Props = {
  children?: React.ReactElement;
  title?: string;
  description?: string | React.ReactNode;
  image?: string;
  position?: "right" | "center" | "left";
  [key: string]: any;
};

const Empty: React.FC<Props> = ({
  children,
  title,
  description,
  image,
  position = "center",
  ...props
}) => {
  const pathname = usePathname();
  const params = useParams();
  console.log("params.", params.type);
  return (
    <>
      <div
        {...props}
        className={`w-full flex ${
          position === "right"
            ? "justify-end"
            : position === "left"
            ? "justify-start"
            : "justify-center"
        } `}
      >
        <div className="flex flex-col items-center justify-center max-w-[380px] text-center">
          {image && (
            <img
              src={image as string}
              alt={title}
              className={
                props.imgClassName
                  ? props.imgClassName
                  : "max-h-[150px] max-w-[150px]"
              }
            />
          )}
          <p className="text-[18px] font-[500]">{title}</p>

          {description && <p className="text-[#60677F]">{description}</p>}
          {[
            "request-form",
            "contact-form",
            "enrollment",
            "masterclass-enrollment",
            "session-inquiry",
            "invoice",
            "activity-log",
          ].includes((params.type as string) || pathname) ? null : (
            <div className="py-2 bg-red-500">{children}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default Empty;
